export const downloaddata = () => ({
    "report_name": "",
    "from_date": "",
    "to_date":"",
    "trans_type": "All"
})
